const getDecimal = (num) => {
  let str = num.toString();
  const zeroPos = str.indexOf('.');
  if (zeroPos === -1) return 0;
  str = str.slice(zeroPos);
  return +str;
};

export default getDecimal;
